import { PRODUCTION_COLORS } from "../../productionPalette";
import "./productionFunnelChart.css";

const ProductionFunnelChart = ({ data, onBarClick }) => {
  const max = Math.max(...data.map((item) => item.value), 1);

  return (
    <div className="funnelList">
      {data.map((item, index) => {
        const widthPct = Math.max((item.value / max) * 100, item.value > 0 ? 6 : 3);
        const color = PRODUCTION_COLORS[index % PRODUCTION_COLORS.length];
        const conversion =
          index > 0 && data[index - 1].value > 0
            ? Math.round((item.value / data[index - 1].value) * 100)
            : null;

        return (
          <button
            key={item.label}
            type="button"
            className="funnelRow"
            onClick={() => onBarClick?.(index)}
            aria-label={`${item.label} : ${item.value}`}
          >
            <span className="funnelLabel">{item.label}</span>
            <span className="funnelTrack">
              <span className="funnelBar" style={{ width: `${widthPct}%`, backgroundColor: color }}>
                <span className="funnelBarValue">{item.value}</span>
              </span>
            </span>
            <span className="funnelConversion">{conversion !== null ? `${conversion}%` : ""}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ProductionFunnelChart;
